// /* global BigInt */
// import React, { useState } from "react";

// export default function Registers({
//   registers,
//   setRegisters,
//   pc,
//   setPc,
//   regView,
//   setRegView,
//   addLog
// }) {
//   const [editingReg, setEditingReg] = useState(null);
//   const [tempRegValue, setTempRegValue] = useState("");

//   // ---------------- FORMATTING ----------------
//   const toInt64 = (n) => BigInt.asIntN(64, BigInt(n));

//   // 🔥 NEW: group binary into 4-bit chunks
//   const groupBinary = (binStr) =>
//     binStr.match(/.{1,4}/g)?.join(" ") ?? binStr;

//   const formatRegisterForView = (hexStr, view) => {
//     const val = BigInt("0x" + hexStr);

//     if (view === "hex") {
//       return "0x" + val.toString(16).padStart(16, "0").toUpperCase();
//     }

//     if (view === "bin") {
//       const raw = val.toString(2).padStart(64, "0");
//       return "0b" + groupBinary(raw);
//     }

//     return toInt64(val).toString();
//   };

//   const parseInput = (input, view) => {
//     if (!input) return null;
//     try {
//       switch (view) {
//         case "hex": return BigInt(input.startsWith("0x") ? input : "0x" + input);
//         case "dec": return BigInt(input);
//         case "bin": return BigInt(input.startsWith("0b") ? input : "0b" + input.replace(/\s+/g, ""));
//         default: return null;
//       }
//     } catch {
//       return null;
//     }
//   };

//   // ---------------- SAVE REGISTER ----------------
//   const saveRegister = (i) => {
//     const num = parseInput(tempRegValue, regView);
//     if (num === null) {
//       addLog(`Invalid input for Register x${i}`);
//       setEditingReg(null);
//       return;
//     }
//     if (num < 0n || num > 0xFFFFFFFFFFFFFFFFn) {
//       addLog(`Error: Cannot store value in Register x${i}, max 64 bits allowed`);
//       setEditingReg(null);
//       return;
//     }

//     const hexValue = num.toString(16).padStart(16, "0").toUpperCase();
//     const updated = [...registers];
//     updated[i] = hexValue;
//     setRegisters(updated);
//     setEditingReg(null);
//     addLog(`Register x${i} updated`);
//   };

//   // ---------------- SAVE PC ----------------
//   const savePc = (value) => {
//     const num = parseInput(value, regView);
//     if (num === null) {
//       addLog(`Invalid input for PC`);
//       setEditingReg(null);
//       return;
//     }
//     if (num < 0n || num > 0xFFFFFFFFFFFFFFFFn) {
//       addLog(`Error: Cannot store value in PC, max 64 bits allowed`);
//       setEditingReg(null);
//       return;
//     }
//     setPc(num);
//     setEditingReg(null);
//     addLog(`PC updated`);
//   };

//   const buttonStyle = (active) => ({
//     marginRight: "5px",
//     padding: "2px 6px",
//     border: "1px solid #888",
//     borderRadius: "4px",
//     background: active ? "#0f0" : "#222",
//     color: active ? "#000" : "#fff",
//     cursor: "pointer",
//     fontWeight: active ? "bold" : "normal",
//     fontFamily: "monospace",
//   });

//   return (
//     <div
//       style={{
//         flex: 1.6,
//         border: "2px solid #333",
//         borderRadius: "6px",
//         margin: "5px",
//         background: "#1b1b1b",
//         display: "flex",
//         flexDirection: "column",
//         overflow: "hidden",
//       }}
//     >
//       {/* ================= STICKY HEADER ================= */}
//       <div
//         style={{
//           position: "sticky",
//           top: 0,
//           background: "#1b1b1b",
//           zIndex: 10,
//           padding: "10px",
//           borderBottom: "1px solid #555",
//         }}
//       >
//         <h3 style={{ marginTop: 0 }}>Registers</h3>

//         <div style={{ marginBottom: "8px" }}>
//           <span style={{ marginRight: "10px" }}>View:</span>
//           <span style={buttonStyle(regView === "hex")} onClick={() => setRegView("hex")}>HEX</span>
//           <span style={buttonStyle(regView === "dec")} onClick={() => setRegView("dec")}>DEC</span>
//           <span style={buttonStyle(regView === "bin")} onClick={() => setRegView("bin")}>BIN</span>
//         </div>

//         <div style={{ display: "flex", fontWeight: "bold" }}>
//           <span style={{ width: 80 }}>Register</span>
//           <span style={{ flex: 1 }}>Value</span>
//         </div>
//       </div>

//       {/* ================= SCROLLABLE BODY ================= */}
//       <div
//         style={{
//           flex: 1,
//           overflowY: "auto",
//           padding: "10px",
//           display: "flex",
//           flexDirection: "column",
//           gap: "6px",
//         }}
//       >
//         {/* PC */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             minHeight: "2em",
//             background: "#111",
//             padding: "6px 10px",
//             border: "1px solid #888",
//             borderRadius: "4px",
//           }}
//         >
//           <div style={{ width: 80, flexShrink: 0 }}><strong>PC</strong></div>

//           <div
//             style={{
//               flex: 1,
//               overflowX: "auto",
//               whiteSpace: "nowrap",
//               fontFamily: "monospace",
//             }}
//           >
//             {formatRegisterForView(
//               pc.toString(16).padStart(16, "0"),
//               regView
//             )}
//           </div>
//         </div>

//         {/* REGISTERS */}
//         {registers.map((value, i) => {
//           const locked = i === 0 || i === 2;
//           const isEditing = editingReg === i;

//           return (
//             <div
//               key={i}
//               onDoubleClick={() => !locked && setEditingReg(i)}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 minHeight: "2em",
//                 background: locked ? "#222" : "#111",
//                 padding: "6px 10px",
//                 border: "1px solid #888",
//                 borderRadius: "4px",
//                 cursor: locked ? "default" : "pointer",
//               }}
//             >
//               <div style={{ width: 80, flexShrink: 0 }}>
//                 <strong>x{i}</strong>
//               </div>

//               {isEditing ? (
//                 <input
//                   value={tempRegValue}
//                   onChange={(e) => setTempRegValue(e.target.value)}
//                   onBlur={() => saveRegister(i)}
//                   onKeyDown={(e) => e.key === "Enter" && saveRegister(i)}
//                   autoFocus
//                   style={{
//                     width: "200px",
//                     background: "#222",
//                     color: "cyan",
//                     border: "1px solid #666",
//                     padding: "2px 4px",
//                     fontFamily: "monospace",
//                   }}
//                 />
//               ) : (
//                 <div
//                   style={{
//                     flex: 1,
//                     overflowX: "auto",
//                     whiteSpace: "nowrap",
//                     fontFamily: "monospace",
//                   }}
//                 >
//                   {formatRegisterForView(value, regView)}
//                 </div>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }


/* global BigInt */
import React, { useState } from "react";

export default function Registers({
  registers,
  setRegisters,
  pc,
  setPc,
  regView,
  setRegView,
  addLog
}) {
  const [editingReg, setEditingReg] = useState(null);
  const [tempRegValue, setTempRegValue] = useState("");

  // ---------------- FORMATTING ----------------
  const toInt64 = (n) => BigInt.asIntN(64, BigInt(n));

  const groupBinary = (binStr) =>
    binStr.match(/.{1,4}/g)?.join(" ") ?? binStr;

  const formatRegisterForView = (hexStr, view) => {
    const val = BigInt("0x" + hexStr);

    if (view === "hex") {
      return "0x" + val.toString(16).padStart(16, "0").toUpperCase();
    }

    if (view === "bin") {
      const raw = val.toString(2).padStart(64, "0");
      return "0b" + groupBinary(raw);
    }

    return toInt64(val).toString();
  };

  const parseInput = (input, view) => {
    if (!input) return null;
    try {
      switch (view) {
        case "hex": return BigInt(input.startsWith("0x") ? input : "0x" + input);
        case "dec": return BigInt(input);
        case "bin": return BigInt(input.startsWith("0b") ? input : "0b" + input.replace(/\s+/g, ""));
        default: return null;
      }
    } catch {
      return null;
    }
  };

  // ---------------- REGISTER ROLE (TOOLTIP) ----------------
  const getRegisterRole = (i) => {
    if (i === 0) return "Zero register (constant 0)";
    if (i === 1) return "Return address register";
    if (i === 2) return "Stack pointer";
    if (i === 3) return "Global pointer";
    if (i === 4) return "Thread pointer";
    if (i >= 5 && i <= 7) return "Temporary register";
    if (i === 8) return "Frame pointer";
    if (i === 9 || (i >= 18 && i <= 27)) return "Saved register";
    if (i >= 10 && i <= 11) return "Function argument / return value";
    if (i >= 12 && i <= 17) return "Function argument";
    if (i >= 28 && i <= 31) return "Temporary register";
    return "";
  };

  // ---------------- SAVE REGISTER ----------------
  const saveRegister = (i) => {
    const num = parseInput(tempRegValue, regView);
    if (num === null) {
      addLog(`Invalid input for Register x${i}`);
      setEditingReg(null);
      return;
    }
    if (num < 0n || num > 0xFFFFFFFFFFFFFFFFn) {
      addLog(`Error: Cannot store value in Register x${i}, max 64 bits allowed`);
      setEditingReg(null);
      return;
    }

    const hexValue = num.toString(16).padStart(16, "0").toUpperCase();
    const updated = [...registers];
    updated[i] = hexValue;
    setRegisters(updated);
    setEditingReg(null);
    addLog(`Register x${i} updated`);
  };

  // ---------------- SAVE PC ----------------
  const savePc = (value) => {
    const num = parseInput(value, regView);
    if (num === null) {
      addLog(`Invalid input for PC`);
      setEditingReg(null);
      return;
    }
    if (num < 0n || num > 0xFFFFFFFFFFFFFFFFn) {
      addLog(`Error: Cannot store value in PC, max 64 bits allowed`);
      setEditingReg(null);
      return;
    }
    setPc(num);
    setEditingReg(null);
    addLog(`PC updated`);
  };

  const buttonStyle = (active) => ({
    marginRight: "5px",
    padding: "2px 6px",
    border: "1px solid #888",
    borderRadius: "4px",
    background: active ? "#0f0" : "#222",
    color: active ? "#000" : "#fff",
    cursor: "pointer",
    fontWeight: active ? "bold" : "normal",
    fontFamily: "monospace",
  });

  return (
    <div
      style={{
        flex: 1.6,
        border: "2px solid #333",
        borderRadius: "6px",
        margin: "5px",
        background: "#1b1b1b",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* ================= STICKY HEADER ================= */}
      <div
        style={{
          position: "sticky",
          top: 0,
          background: "#1b1b1b",
          zIndex: 10,
          padding: "10px",
          borderBottom: "1px solid #555",
        }}
      >
        {/* <h3 style={{ marginTop: 0 }}>Registers</h3> */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px" 
          }}
        >
          <h3 style={{ margin: 0 }}>Registers</h3>
          <h6 style={{ margin: 0, fontWeight: "normal", opacity: 0.8, fontSize:"15px" }}>
            © 2026 Partha Bhoumik | Beta v1.0 
          </h6>
        </div>

        <div style={{ marginBottom: "8px" }}>
          <span style={{ marginRight: "10px" }}>View:</span>
          <span style={buttonStyle(regView === "hex")} onClick={() => setRegView("hex")}>HEX</span>
          <span style={buttonStyle(regView === "dec")} onClick={() => setRegView("dec")}>DEC</span>
          <span style={buttonStyle(regView === "bin")} onClick={() => setRegView("bin")}>BIN</span>
        </div>

        <div style={{ display: "flex", fontWeight: "bold" }}>
          <span style={{ width: 80 }}>Register</span>
          <span style={{ flex: 1 }}>Value</span>
        </div>
      </div>

      {/* ================= SCROLLABLE BODY ================= */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        {/* PC */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            minHeight: "2em",
            background: "#111",
            padding: "6px 10px",
            border: "1px solid #888",
            borderRadius: "4px",
          }}
          title="Program Counter"
        >
          <div style={{ width: 80, flexShrink: 0 }}><strong>PC</strong></div>

          <div
            style={{
              flex: 1,
              overflowX: "auto",
              whiteSpace: "nowrap",
              fontFamily: "monospace",
            }}
          >
            {formatRegisterForView(
              pc.toString(16).padStart(16, "0"),
              regView
            )}
          </div>
        </div>

        {/* REGISTERS */}
        {registers.map((value, i) => {
          const locked = i === 0 || i === 2;
          const isEditing = editingReg === i;

          return (
            <div
              key={i}
              title={getRegisterRole(i)}
              onDoubleClick={() => !locked && setEditingReg(i)}
              style={{
                display: "flex",
                alignItems: "center",
                minHeight: "2em",
                background: locked ? "#222" : "#111",
                padding: "6px 10px",
                border: "1px solid #888",
                borderRadius: "4px",
                cursor: locked ? "default" : "pointer",
              }}
            >
              <div style={{ width: 80, flexShrink: 0 }}>
                <strong>x{i}</strong>
              </div>

              {isEditing ? (
                <input
                  value={tempRegValue}
                  onChange={(e) => setTempRegValue(e.target.value)}
                  onBlur={() => saveRegister(i)}
                  onKeyDown={(e) => e.key === "Enter" && saveRegister(i)}
                  autoFocus
                  style={{
                    width: "200px",
                    background: "#222",
                    color: "cyan",
                    border: "1px solid #666",
                    padding: "2px 4px",
                    fontFamily: "monospace",
                  }}
                />
              ) : (
                <div
                  style={{
                    flex: 1,
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    fontFamily: "monospace",
                  }}
                >
                  {formatRegisterForView(value, regView)}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
